module.exports = __webpack_public_path__ + "static/media/md-document-duplicate.d1dee562.svg";